import {
  useTableCreatorFocusStatus,
  DEFAULT_FOCUS_STATUS,
} from "@/components/business/FillInTableContainer/shared/context/TableCreatorFocusStatusContext";

import { DefaultDataSetType } from "../types/tableCreatorDropdown.types";

interface Props {
  changeSelectedValue: (value: string) => void;
  changeTextFieldMarginBottom: (margin: number) => void;
  handleChangeDataSetValue: (value: DefaultDataSetType) => void;
  changeMultiSelectValues?: (items: string[]) => void;
}

export const useClickDropdownItem = ({
  changeSelectedValue,
  changeTextFieldMarginBottom,
  handleChangeDataSetValue,
  changeMultiSelectValues,
}: Props) => {
  const { changeFocusStatus } = useTableCreatorFocusStatus();

  const handleClickAIItem = (item: string) => {
    changeSelectedValue(item);
    changeTextFieldMarginBottom(0);
    changeFocusStatus(DEFAULT_FOCUS_STATUS);
  };

  const handleClickDictionaryItem = (item: string) => {
    changeSelectedValue(item);
  };

  const handleClickDataSetItem = (item: DefaultDataSetType) => {
    handleChangeDataSetValue(item);
  };

  /**
   * Multi-select 모드에서 아이템을 토글한다.
   * 이미 선택된 값이면 제거, 없으면 추가.
   * 드롭다운은 닫지 않는다.
   */
  const handleClickMultiSelectItem = (
    item: string,
    currentValues: string[],
  ) => {
    if (!changeMultiSelectValues) return;
    const isAlreadySelected = currentValues.includes(item);
    const newValues = isAlreadySelected
      ? currentValues.filter((v) => v !== item)
      : [...currentValues, item];
    changeMultiSelectValues(newValues);
  };

  return {
    handleClickAIItem,
    handleClickDictionaryItem,
    handleClickDataSetItem,
    handleClickMultiSelectItem,
  };
};
